import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import SearchBar from './SearchBar';
import Notifications from './Notifications';

const Navigation = () => {
  const { user, logout } = useContext(AuthContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
    <nav>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img 
            src="/ASNlogo.png" 
            alt="Alien Social Network Logo" 
            className="logo-image"
          />
          <span className="logo-text">Alien Social Network</span>
        </Link>
        
        {/* Hamburger menu button for mobile */}
        <button 
          className="mobile-menu-toggle" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        <ul className={`nav-links ${mobileMenuOpen ? 'nav-links-mobile-open' : ''}`}>
          {user ? (
            <>
              <li><Link to="/" onClick={closeMobileMenu}>Feed</Link></li>
              <li><Link to="/pages" onClick={closeMobileMenu}>Pages</Link></li>
              <li><Link to="/connections" onClick={closeMobileMenu}>Connections</Link></li>
              <li><Link to="/messages" onClick={closeMobileMenu}>Messages</Link></li>
              <li className="notification-nav-item">
                <Notifications />
              </li>
              <li><Link to={`/${user.username}`} onClick={closeMobileMenu}>Profile</Link></li>
              <li><button onClick={handleLogout}>Logout</button></li>
            </>
          ) : (
            <>
              <li><Link to="/login" onClick={closeMobileMenu}>Login</Link></li>
              <li><Link to="/register" onClick={closeMobileMenu}>Register</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
    {user && (
      <div className="search-bar-wrapper">
        <SearchBar />
      </div>
    )}
    </>
  );
};

export default Navigation;
